import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDiscountFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.3 8a.7.7 0 00.2-.49V3.23c0-.4-.33-.73-.73-.73H8.5c-.21 0-.41.1-.55.26L2.68 8.03a.72.72 0 000 .95l4.34 4.34c.24.24.71.24.95 0L13.29 8zM11 4a1 1 0 110 2 1 1 0 010-2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicDiscountFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDiscountFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicDiscountFilled svgRef={ref} {...props} />
));
export default ForwardRef;
